import * as React from 'react';

import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

export default function BasicTable(props) {

  const monthsOrder = [
    "Décembre_N-1", "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
    "Juillet", "Aout", "Septembre", "Octobre", "Novembre", "Décembre"
  ];

  const sortedRows = monthsOrder.map(month => ({
    month,
    amount: parseFloat((props.rows[month] || "0").replace(",", ".")) || 0
  }));

  const totalAmount = sortedRows.reduce((total, row) => total + row.amount, 0);

  return (
      <Table sx={{ width: "250px" }} aria-label="simple table" style={{position: "absolute", right: "100px", top: '100px', border: "1px solid grey" }}>
        <TableHead>
          <TableRow>
            <TableCell style={{fontWeight: "900"}}>Mois</TableCell>
            <TableCell style={{fontWeight: "900"}} align="right">montant</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {sortedRows.map(({month, amount}) => (
            <TableRow
              key={month}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
                {month}
              </TableCell>
                <TableCell align="right">{amount.toLocaleString("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 })} €</TableCell>
              </TableRow>
          ))}
          <TableRow style={{backgroundColor: "rgb(2, 150, 2, 0.5)"}}>
            <TableCell component="th" scope="row">
                Total
            </TableCell>
            <TableCell align="right">{totalAmount} €</TableCell>
          </TableRow>
        </TableBody>
      </Table>
  );
}